import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(
    nominativo: string,
    causale: string,
    chilometri: number
  ) {
    return { nominativo, causale, chilometri};
  }
  
  const rows = [
    createData('Mario Rossi', "Provette", 6.0),
    createData('Giuseppe Bianchi', "Analisi", 9.0),
    createData('Alessio Russo', "Visita", 16.0),
    createData('Giovanni Rossi', "Provette", 6.0),
    createData('Federico Grande', "Analisi", 9.0),
  ];

type Props = {};

const CalendarioTrasportiPage = (props: Props) => {

    const [value, setValue] = React.useState<Dayjs | null>();
    const [viewDetails, setviewDetails] = React.useState(false);


    return (
      <div>
        <h2>Calendario Trasporti</h2>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar onChange={(newValue) => {
                setValue(newValue);
                setviewDetails(true);
                }            
            } />
        </LocalizationProvider>
        <div className={viewDetails? 'hidden' : undefined}>
            <p>{value?.toString()}</p>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>Nominativo</TableCell>
                        <TableCell align="right">Tipo Trasporto</TableCell>
                        <TableCell align="right">Chilometri</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {rows.map((row) => (
                        <TableRow
                        key={row.nominativo}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell component="th" scope="row">
                            {row.nominativo}
                        </TableCell>
                        <TableCell align="right">{row.causale}</TableCell>
                        <TableCell align="right">{row.chilometri} km</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                </TableContainer>
        </div>
      </div>
    );
  };
  
  export default CalendarioTrasportiPage;